import {LauncherComponentBase} from '../base-components/launcher-component-base';
import {observer} from 'mobx-react';

@observer
export class LauncherRouterOutletComponent extends LauncherComponentBase<{}> {
    render() {
        return this.services.routing.currentRoute.render();
    }
}